{
  "$schema": "http://adaptivecards.io/schemas/adaptive-card.json",
  "type": "AdaptiveCard",
  "version": "1.5",
  "body": [],
  "actions": [
    {
      "type": "Action.Submit",
      "title": "${retryLabel}",
      "data": {
        "action": "chat.retry_last_turn"
      }
    }
  ]
}
